import React from 'react';

const FORWARD_LABELS = new Set([
  'Continuer',
  'Paiement',
  'Confirmer et payer',
  'Demander un devis',
  'Confirmer la réservation',
  'Traitement...',
]);

const isStepNavButton = (child) => {
  if (!React.isValidElement(child)) return false;

  const { iconName, children, iconPosition } = child.props || {};

  if (iconName === 'ArrowLeft' || iconName === 'ArrowRight') return true;
  if (iconName === 'CheckCircle' && iconPosition === 'right') return true;
  if (iconName === 'Send' && iconPosition === 'right') return true;
  if (iconName === 'Loader' && iconPosition === 'right') return true;

  if (typeof children === 'string' && (children === 'Retour' || FORWARD_LABELS.has(children))) {
    return true;
  }

  return false;
};

const StepActions = ({ isActive = true, showBack = true, children, className = '' }) => {
  if (!isActive) return null;

  // showBack contrôle Retour + Continuer (et autres actions d'étape)
  const content = React.Children.toArray(children).filter(
    (child) => showBack || !isStepNavButton(child)
  );

  if (content.length === 0) return null;

  return <div className={className}>{content}</div>;
};

export default StepActions;
